import axios from './axiosInterceptors';
import authHeader from "./authentification-header";

const API_URL = "/api/v1/purchase-orders/";

const searchPurchaseOrders = (formData) => {
    return axios.post(API_URL + 'search', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const allActions = {
    searchPurchaseOrders,
};

export default allActions;